export function enqueueMediaToggle(queue, operation) {
    const result = queue.current.catch(() => false).then(operation);
    queue.current = result.catch(() => false);
    return result;
}
export async function toggleLocalVideoTrack({ track, deviceId, createDeviceTrack, }) {
    if (!track.isMuted) {
        await track.mute();
        return true;
    }
    if (!deviceId) {
        throw new Error('Local video device is not specified');
    }
    const mediaStreamTrack = await createDeviceTrack(deviceId, 'video');
    if (!mediaStreamTrack) {
        throw new Error('Failed to create local video track');
    }
    await track.replaceTrack(mediaStreamTrack, { userProvidedTrack: false });
    await track.unmute();
    return false;
}
export async function switchLocalVideoDevice(track, deviceId, isMuted, captureOptions) {
    await track.restartTrack({ deviceId, ...captureOptions });
    if (!isMuted && track.isMuted) {
        await track.unmute();
    }
}
